import React from "react";
import { t } from "ttag";

import { Link } from "../../common/Link";
import { IWebPageURL } from "../../models/nominals";
import { trackSleepExpertEvent } from "../../utils/analytics";
import { urls } from "../../utils/urls";
import { getChatConnector } from "./index";

interface IProps {
    className?: string;
    chatOnlineText?: string | React.ReactNode;
    chatOfflineText?: string | React.ReactNode;
    hideIfOffline?: boolean;
    chatOfflineLink: IWebPageURL;
}

export const ChatLink = (props: IProps): React.ReactNode => {
    const [isChatOnline, setIsChatOnline] = React.useState(false);

    React.useEffect(() => {
        const initializeChat = async () => {
            try {
                const { isOnline } = await getChatConnector().init();
                setIsChatOnline(isOnline);
            } catch (e) {
                console.error(e);
            }
        };

        initializeChat();
    }, []);

    const onClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        if (isChatOnline) {
            getChatConnector().openChat();
            trackSleepExpertEvent("chat");
        } else {
            urls.navigateToURL(props.chatOfflineLink);
        }
    };

    if (isChatOnline) {
        return (
            <button className={props.className} onClick={onClick}>
                {props.chatOnlineText || t`Chat`}
            </button>
        );
    }
    if (props.hideIfOffline) {
        return null;
    }
    return (
        <Link className={props.className} href={props.chatOfflineLink}>
            {props.chatOfflineText || t`Contact Us`}
        </Link>
    );
};
